import { getDayOfWeek } from '@/src/general/primitives/dates/dayjs'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TMediumCommunityApi } from '../../api/communityApi.types'
import { COMMUNITY_PUBLICATION_FREQUENCY } from '../../models/community.constants'

export type TCommunityFrequencyProps = Pick<
  TMediumCommunityApi,
  'publicationFrequencyType' | 'publicationFrequencyValue'
> & { short?: boolean }

export const useCommunityFrequencyText = ({
  publicationFrequencyType,
  publicationFrequencyValue,
  short,
}: TCommunityFrequencyProps) => {
  const { t } = useTranslate()

  return {
    [COMMUNITY_PUBLICATION_FREQUENCY.DAILY]: t(
      short ? 'publication.frequency.type.daily' : 'publication.frequency.type.long.daily',
    ),
    [COMMUNITY_PUBLICATION_FREQUENCY.WEEKLY]: t(
      short ? 'publication.frequency.type.weekly' : 'publication.frequency.type.long.weekly',
      {
        value: getDayOfWeek(publicationFrequencyValue ?? 1),
      },
    ),
    [COMMUNITY_PUBLICATION_FREQUENCY.MONTHLY]: t(
      short ? 'publication.frequency.type.monthly' : 'publication.frequency.type.long.monthly',
      {
        value: publicationFrequencyValue ?? 1,
      },
    ),
    [COMMUNITY_PUBLICATION_FREQUENCY.SPORADICALLY]: t(
      short ? 'publication.frequency.type.sporadically' : 'publication.frequency.type.long.sporadically',
    ),
  }[publicationFrequencyType]
}
